import React, { ReactElement } from 'react';
import AntLayout from 'antd/es/layout';
import { Button, Space, theme } from 'antd';
import styles from './footer.module.css';
import { getBackgroundColorWithOpacity } from '@seaters/ui';
import { getSlugFromUrl, queryClient } from '@seaters/data-access';
import { useTranslation } from 'react-i18next';
import { LookEntity } from '@seaters/constants';
import cx from 'classnames';

type ButtonSize = 'large' | 'middle' | 'small';

export interface FooterProps {
  children?: ReactElement;
  onCancel?: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  formName?: string;
  className?: string;
  size?: ButtonSize;
  buttonSize?: ButtonSize;
}
const { Footer: AntFooter } = AntLayout;

export function Footer({
  onCancel,
  formName,
  isDisabled,
  isLoading,
  children,
  className,
  size,
  buttonSize,
}: FooterProps) {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const resolvedButtonSize = buttonSize ?? size ?? 'large';
  const slug = getSlugFromUrl();
  const fanGroupData: LookEntity | undefined = queryClient
    .getQueryCache()
    .find<LookEntity>({ queryKey: ['users', 'look'], exact: false })
    ?.state.data;

  const customPrimaryColor = fanGroupData?.color;

  const backgroundColorWithOpacity = getBackgroundColorWithOpacity(
    customPrimaryColor ? `#${customPrimaryColor}` : undefined
  );
  const footerBackgroundColor = slug
    ? backgroundColorWithOpacity
    : token.colorBgContainer;
  return (
    <AntFooter
      className={cx(!slug ? styles.footer : styles.footerFan, className)}
      style={{
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        backgroundColor: footerBackgroundColor,
      }}
    >
      {children}
      <Space>
        {/* Shared footer: several can render on one screen, so tests scope these hooks by their form. */}
        <Button
          data-testid="formFooterCancelButton"
          size={resolvedButtonSize}
          onClick={onCancel}
          disabled={isDisabled}
        >
          {t('button_text_cancel')}
        </Button>
        <Button
          data-testid="formFooterSubmitButton"
          form={formName}
          size={resolvedButtonSize}
          type="primary"
          htmlType="submit"
          disabled={isDisabled}
          loading={isLoading}
        >
          {t('button_text_save')}
        </Button>
      </Space>
    </AntFooter>
  );
}

export default Footer;
